// project import
import user from './user';
import exam from './exam';
// ==============================|| MENU ITEMS ||============================== //
let items = [exam, user]

const menuItems = {
  items: items
};

export default menuItems;
